import React from "react";
import { Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service";

interface EyeIconProps {
  published: boolean;
  size?: number;
}

const EyeIcon: React.FC<EyeIconProps> = ({ published, size = 20 }) => {
  return published ? (
    // Published → Open Eye
    <Image
      src={dynamicImage("eye-open.svg")}
      alt="Published"
      style={{
        width: size,
        height: size,
        filter: "brightness(0) invert(1)", // make it white
      }}
    />
  ) : (
    // Unpublished → Closed Eye
    <Image
      src={dynamicImage("eye-closed.svg")}
      alt="Unpublished"
      style={{
        width: size,
        height: size,
        filter: "brightness(0) invert(1)", // make it white
      }}
    />
  );
};

export default EyeIcon;
